export const QUIZ_CONTENT_CONFIG = {
  1: 'quiz_v1',
  2: 'quiz_v2',
  3: 'quiz_v3',
  4: 'quiz_v4',
  5: 'quiz_v5',
  9: 'quiz_v9',
  default: 'quiz_v3'
}
